import { useEffect, useState } from "react";
import { Item } from "../../../../../models/assessments";
import { Box, Button, Checkbox, Collapse, FormControl, FormControlLabel, FormGroup, Paper, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";
import { isRichTextContentEmpty } from "../../../../../utils/rich-text-empty";
import { RenderRichText } from "../../../../../components/render-rich-text";
import { CheckBox } from "@mui/icons-material";

interface ObjectiveViewProps {
    item: Item;
    register: (id: string, getItem: () => Item) => void;
    setResource: React.Dispatch<React.SetStateAction<string>>;
}

export default function ObjectiveView({ item, register, setResource }: ObjectiveViewProps) {
    const [locItem, setLocItem] = useState<Item>({
        ...item,
        answer: item.answer ? item.answer : item.type === 3 ? '' : []
    });

   const handleAnswerChange = (value: any) => {
        let updatedAnswer;

        if (item.type === 3) {
            updatedAnswer = value;
        } else {
            updatedAnswer = locItem.answer.includes(value)
                ? locItem.answer.filter((o: string) => o !== value)
                : [...locItem.answer, value];
        }

        const updatedItem = { ...locItem, answer: updatedAnswer };
        setLocItem(updatedItem);

        register(item.id, () => updatedItem);
    };



    return (
        <Paper
            key={item.id}
            elevation={1}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 3,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                backgroundColor: '#fff',
                gap: 2
            }}
        >
            {(item.title || item.required || item.marks) && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        {!isRichTextContentEmpty(item.title) && (
                            <RenderRichText jsonContent={item.title} />
                        )}
                        {(item.type !== 0 && item.required) && (
                            <Typography color="error">*</Typography>
                        )}
                    </Box>

                        <Typography variant="caption" color="text.secondary">
                        {item.marks} mark{item.marks !== 1 ? 's' : ''}
                    </Typography>
                </Box>
            )}

            {!isRichTextContentEmpty(item.description) && (
                <Box>
                    <RenderRichText jsonContent={item.description} />
                </Box>
            )}
            
            {item.resources?.length > 0 && (
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{ overflowX: "auto",}}
                >
                    {item.resources.map((res, i) => {
                        const handleResourceClick = () => {
                            setResource(res);
                        };

                        return (
                            <Box
                                key={i}
                                component="img"
                                src={res}
                                alt={`resource-${i}`}
                                onClick={handleResourceClick}
                                sx={{
                                    width: 48,
                                    height: 48,
                                    objectFit: 'cover',
                                    borderRadius: 1,
                                    cursor: 'pointer',
                                    border: '1px solid #ccc',
                                }}
                            />
                        );
                    })}
                </Stack>
            )}
    
           {item.type === 3 && item.options?.length > 0 && (
                <FormControl component="fieldset" >
                    <RadioGroup
                        value={locItem.answer}
                        onChange={(e) => handleAnswerChange(e.target.value)}
                    >
                        {item.options.map((opt, i) => (
                            <FormControlLabel
                                key={i}
                                value={opt}
                                control={<Radio />}
                                label={opt}
                            />
                        ))}
                    </RadioGroup>

                    <Collapse in={Boolean(item.answer)}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button size="small" onClick={() => handleAnswerChange("")}>
                                Clear Selection
                            </Button>
                        </Box>
                    </Collapse>
                </FormControl>
            )}

               
            {item.type === 4 && item.options.length > 0 && (
                <FormGroup sx={{ mt: 2 }}>
                    {item.options.map((opt, i) => (
                        <FormControlLabel
                            key={i}
                            control={
                                <Checkbox
                                    checked={locItem.answer.includes(opt)}
                                    onChange={() => handleAnswerChange(opt)}
                                />
                            }
                            label={opt}
                        />
                    ))}
                </FormGroup>
            )}


        </Paper>
    )
}
